module.exports = __webpack_public_path__ + "img/bg2.ee6f6f36.png";